const awsconfig = {
  region: "us-west-2",
  identityPoolId: "us-west-2:812968d4-ba8f-4317-be2c-5f192c53ff61",
  userPoolId: "us-west-2_VKLIH87qS",
  userPoolWebClientId: "39ug18av0jb00lom0paumbs54j"
};

export default awsconfig;
